import React from "react";
import PgAbout from "../Components/PgAbout";

function Aboutpage() {
  return (
    <>
      <PgAbout />
    </>
  );
}

export default Aboutpage;
